import React from "react";

const HeroSection = ({ title, description, video, brand }) => {
  return (
    <div className="relative w-full h-screen overflow-hidden">
      {/* Background Video */}
      <video
        className="absolute object-cover w-full h-full inset-0 z-0"
        src={video}
        autoPlay
        loop
        muted
        playsInline
      />
      {/* Dark Overlay */}
      <div className="absolute inset-0 bg-black/50 z-[1]" />

      {/* Content */}
      <div className="relative z-[2] flex flex-col items-center justify-center h-full text-center text-white px-4">
        <h2 className="text-3xl md:text-4xl">{title}</h2>
        <h1 className="text-6xl md:text-8xl font-bold text-[#FF6838] my-4">
          {brand}
        </h1>
        <p className="text-lg md:text-xl max-w-3xl">
          {description}
        </p>
      </div>
    </div>
  );
};

export default HeroSection;
